Ext.ns('mx.comp');

mx.comp.EditedTextArea = Ext.extend(Ext.form.TwinTriggerField, {
    trigger1Class: 'x-form-editedtextarea-trigger-add',
    trigger2Class: 'x-form-editedtextarea-trigger-edit',
    initComponent: function() {
        this.defaultAutoCreate = {
            tag: 'textarea',
            style: 'width:100px;height:60px;',
            autocomplete: 'off',
        };
        mx.comp.EditedTextArea.superclass.initComponent.call(this, arguments);
    },
    onRender: function(ct, position) {
        mx.comp.EditedTextArea.superclass.onRender.call(this, ct, position);
        this.el.dom.disabled = true;
    },
    processOnAdd: function(text) {
        this.setValue(text + '\n\n' + this.getValue());
    },
    onTrigger1Click: function() {
        if (!this.disabled) {
            Ext.Msg.prompt(
                'Add comment',
                'Enter comment',
                function(btn, text) {
                    if (btn == 'ok') {
                        this.processOnAdd(text);
                    }
                },
                this,
                true,
                ''
            );
        }
    },
    setDisabled: function(v) {
        mx.comp.EditedTextArea.superclass.setDisabled.call(this, v);
        if (this.el) {
            this.el.dom.disabled = true;
        }
    },
    onTrigger2Click: function() {
        if (!this.disabled) {
            this.el.dom.disabled = false;
        }
    },
});
